/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material';
import { TeamAssignmentItem } from './TeamAssignmentItem/TeamAssignmentItem';
import { TEAM_ASSIGNMENT_LIST } from '../../../../constants';
import { useTelegram } from '../../../../hooks/useTelegram';

export function TeamAssignmentList() {
    const { colorScheme } = useTelegram();

    return (
        <Box marginBottom={2}>
            {TEAM_ASSIGNMENT_LIST.map((teamItem) => (
                <TeamAssignmentItem
                    color={teamItem.color}
                    text={teamItem.text}
                    colorScheme={colorScheme}
                />
            ))}
        </Box>
    );
}
